import {
  getWithExpiry,
  isChunkFailedError,
  LinkExpiredError,
} from "../../utils/error";
import { useEffect, useRef } from "react";
import { LinkExpired } from "./link-expired";
import { SomethingWentWrong } from "./went-wrong";

export * from "./went-wrong";
export * from "./link-expired";

export const ErrorComponent = ({
  error,
  onError,
}: {
  error: Error;
  onError: (e: Error) => void;
}) => {
  const isChunkFailed = error?.message && isChunkFailedError(error);
  const reloadAttemptedRecently = !!getWithExpiry("chunk_failed");

  const errorHandler = useRef(onError);
  errorHandler.current = onError;

  useEffect(() => {
    if (error) errorHandler.current(error);
  }, [error, onError]);

  if (isChunkFailed && !reloadAttemptedRecently) {
    window.location.reload();
    return null;
  }

  if (error instanceof LinkExpiredError) {
    return <LinkExpired />;
  }

  return <SomethingWentWrong error={error} />;
};
